// extracted by mini-css-extract-plugin
export var fadeIn = "_fc-1";
export var modalContent = "_fc-3";
export var overlay = "_fc-0";
export var popoverContent = "_fc-2";
export var results = "_fc-5";
export var searchInputWrapper = "_fc-4";